import { Map } from 'immutable';

import { TAGS_GET_REQUEST, TAGS_GET_FAILURE, TAGS_GET_SUCCESS } from './action';

const initialState = Map({
  type: '',
  data: {},
  payload: [],
});

function reducer(state = initialState, action) {
  const { type, data } = action;

  if (type === TAGS_GET_REQUEST) {
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => true)
      .updateIn(['isLoaded'], () => false)
      .updateIn(['data'], () => data)
      .setIn(['payload'], []);
  }

  if (type === TAGS_GET_FAILURE) {
    const { payload } = action;
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => false)
      .updateIn(['isLoaded'], () => false)
      .setIn(['payload'], payload);
  }

  if (type === TAGS_GET_SUCCESS) {
    const { payload } = action;
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => false)
      .updateIn(['isLoaded'], () => true)
      .setIn(['payload'], payload);
  }

  return state;
}

export default reducer;
